// this is replaced with the actual package version by rollup
export const PACKAGE_VERSION = '__buildVersion__';

export default PACKAGE_VERSION;
